export enum CashMovementType {

  OPENING = "OPENING",

  SALE = "SALE",

  INCOME = "INCOME",

  WITHDRAWAL = "WITHDRAWAL",

  REFUND = "REFUND",

  ADJUSTMENT_IN = "ADJUSTMENT_IN",

  ADJUSTMENT_OUT = "ADJUSTMENT_OUT",

  CXP_PAYMENT = "CXP_PAYMENT",

  CXC_PAYMENT = "CXC_PAYMENT"

}